module.exports = __webpack_public_path__ + "img/sld_scb_25_t1_b1_green.ca9fbf1a.svg";